 import React from 'react'
import { useEffect, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const IncompList = props => {

    const panelsdef = [];
    const reportids = {
        "print0": "MIKAN0",
        "print1": "MIKAN1",
        "print2": "MIKAN2"
    };
    const formid = getformid("IncompList", props.location.search);
    const controller = getcontroller("IncompList", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);
    const actionurl = {
        "update": "Forms/Update",
        "getlist": "IncompList/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "print0", icon: "print", label: "未完納リスト発行（未入荷）", title: "未完納リスト発行（未入荷）を出力します" },
        { status: "VIEW", menuid: "print1", icon: "print", label: "未完納リスト発行（最終入荷1ヶ月超）", title: "未完納リスト発行（最終入荷1ヶ月超）を出力します" },
        { status: "VIEW", menuid: "print2", icon: "print", label: "未完納リスト発行（完納候補）", title: "未完納リスト発行（完納候補）を出力します" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    function MenuAction(action, savefinally, GetList, gridApi) {
        if (isEmpty(reportids[action])) return;

        let reportid = reportids[action];
        if (isEmpty(reportid)) {
            fnc.current.warnmsg("未完納リスト発行の設定が見つかりません");
            return;
        }

        const rows = gridApi?.getSelectedRows?.() ?? [];
        if (rows.length === 0) {
            fnc.current.warnmsg("印刷対象データを選択してください");
            return;
        }

        const keys = [...new Set(rows
            .map(row => row.LGK_SSDNO || row.SSD_NO || "")
            .filter(key => !isEmpty(key)))];
        if (keys.length === 0) {
            fnc.current.warnmsg("印刷対象のキーが取得できません");
            return;
        }

        fnc.current.postaxios("common/Printout",
            { controller: controller, id: reportid, keys: keys },
            {
                onSuccess: function (data) {
                    let params = {
                        "excelfile": data.returnData["filename"],
                        "dnfile": data.returnData["dnfile"]
                    };
                    fnc.current.filedownload("excel/ExcelDownload", params);
                    fnc.current.wait(false);
                },
                errmsg: "未完納リスト発行に失敗しました"
            });
    }




    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
                entrycallback={MenuAction}
           >
            </MasterBase>
        </div>
    );
};


